import React, {Component, Fragment} from 'react';
import {autobind} from 'core-decorators';
import {reverse} from 'core/urls';
import {bagForm} from 'components/forms/decorators';
import createLLDealerBagsOrderMutation from 'graphql/mutations/orders/create-ll-dealer-bags.gql';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import OptionsSidebar from 'components/options-sidebar';
import ProductPicker from 'components/product-picker';
import AddressGrid from 'components/address-grid';
import {getDefaultAddress} from 'core/utils';
import {Form, Field, Textarea} from 'components/forms';
import Button from 'components/button';
import styles from '../styles.css';

@bagForm(createLLDealerBagsOrderMutation, 'll_dealer_bags')
@autobind
export default class LLDealerBagsCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='Lado a Lado Distribuidor' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar
                        refundType='ll'
                        userType='dealer'
                        links={['trialSigns']}
                    />
                    <div className={styles.formContainer}>
                        <Form
                            fields={[
                                {key: 'items', initial: []},
                                {key: 'notes', required: false},
                                {
                                    key: 'address', initial: getDefaultAddress(this.props.addressesData),
                                },
                            ]}
                            errors={this.props.errors}
                            onSubmit={this.props.onSubmit}>
                            {({getFieldProps, renderErrors, isValid, values}) => (
                                <Fragment>
                                    <div className={styles.title}>Pedido de bolsas</div>
                                    <Field>
                                        <ProductPicker
                                            items={this.props.itemsData.bags}
                                            perItemLimit={this.props.itemsData.perItemLimit}
                                            toggleSelectedProduct={this.props.toggleSelectedProduct}
                                            {...getFieldProps('items')}
                                        />
                                        {renderErrors('items')}
                                    </Field>
                                    <Field label='Comentarios para Nidera'>
                                        <Textarea {...getFieldProps('notes')} />
                                        {renderErrors('notes')}
                                    </Field>
                                    <Field label='Dirección de envío de las bolsas'>
                                        <AddressGrid
                                            addresses={this.props.addressesData.addresses}
                                            returnUrl={reverse('llDealerBagsCreate')}
                                            returnData={values}
                                            {...getFieldProps('address')}
                                        />
                                        {renderErrors('address')}
                                    </Field>
                                    {renderErrors('__all__')}
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                    </Form.Actions>
                                </Fragment>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/lado-a-lado/dealer/bags/create/index.js